import React, { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useStyles } from '../styles';

interface CertificateActionsMenuProps {
  isOpen: boolean;
  onEdit: () => void;
  onDelete: () => void;
  onClose: () => void;
  position: { top: number; right: number };
}

const CertificateActionsMenu: React.FC<CertificateActionsMenuProps> = ({
  isOpen,
  onEdit,
  onDelete,
  onClose,
  position,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div ref={menuRef} className={classes.actionsMenu} style={{ top: position.top, right: position.right }}>
      <button
        className={classes.menuItem}
        data-testid="certificate-edit-button"
        onClick={e => {
          e.stopPropagation();
          onEdit();
          onClose();
        }}
      >
        {t('common.edit')}
      </button>
      <button
        className={classes.menuItem}
        data-testid="certificate-delete-button"
        onClick={e => {
          e.stopPropagation();
          onDelete();
          onClose();
        }}
      >
        {t('common.delete')}
      </button>
    </div>
  );
};

export default CertificateActionsMenu;
